import React from "react";
import {useRouteLoaderData} from "react-router-dom";
import {URL} from "../../ui/link";
import translate from "../../../../translate";

export default function GroupOverview() {
    /**
     * @type groupDataType
     */
    const groupData = useRouteLoaderData('group');

    return <div>
        <h2>{groupData.name}</h2>

        {groupData.ownPermissions.SeeMemberList ? <div><URL href={'members'}>{translate('page/group/members/pagetitle')}</URL></div> : null}
        {groupData.ownPermissions.SeeInvites ? <div><URL href={'invites'}>{translate('page/group/invites/pagetitle')}</URL></div> : null}
        {groupData.ownPermissions.SeeIncomingAttacks ? <div><URL href={'incomingAttacks'}>{translate('page/group/incomingAttacks/pagetitle')}</URL></div> : null}
    </div>
}
